import { useQuery } from "@tanstack/react-query";
import { fetchDashboardNotes } from "@/api/dashboard";

export function useDashboardNotes() {
  return useQuery({
    queryKey: ["dashboard", "notes"],
    queryFn: fetchDashboardNotes,
    // Thank-you notes arrive over time — refetch on every navigation into the dashboard.
    refetchOnMount: "always",
  });
}
